export enum StreamMode {
  FIXED_FULL = "FIXED_FULL",
  MANUAL_FULL = "MANUAL_FULL",
  INCREMENTAL = "INCREMENTAL",
  APPEND = "APPEND",
}
